import { func, string, oneOfType, shape } from 'prop-types';
export var component = oneOfType([func, string, shape({
  render: func.isRequired
})]);